<template>
  <div class="table-responsive">
    <dynamic-table :columns="datesColumns"
                   :data="dates"
                   :loading="loading"
                   class="table-hover"
                   theadClass="thead-light"
                   empty-message="No existen fechas de reunión">
  
      <template v-slot:date="slotProps">
        {{ (slotProps.row.date) }}
      </template>
      
      <template v-slot:type="slotProps">
        <span v-if="slotProps.index === 0 && dates.length > 1"
              class="badge badge-success">
          En proceso
        </span>
        
        <span v-if="slotProps.index !== 0 && slotProps.index !== dates.length - 1"
              class="badge badge-subtle badge-info">
            Revisión
        </span>
        
        <span v-if="slotProps.index === dates.length - 1"
              class="badge badge-primary">
          Primera revisión
        </span>
      </template>
    
    </dynamic-table>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  
  export default {
    name: 'DatesTable',
    components: {
      DynamicTable,
    },
    props: {
      amendment: Object,
      committee: Object,
    },
    data() {
      return {
        loading: true,
        datesColumns: [
          {
            field: 'date',
            title: 'Fecha',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
          {
            field: 'type',
            title: 'Tipo',
            tdClass: 'align-middle',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        getDateDictum: 'amendments/getDateDictum',
      }),
      
      async load() {
        this.loading = true
        
        const { amendment, committee } = this
        
        await this.getDateDictum({
          amendment,
          committee,
        })
        
        this.loading = false
      },
      
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    computed: {
      ...mapGetters({
        dates: 'amendments/dates',
      }),
    },
    async mounted() {
      await this.load()
    },
  }
</script>
